import { TrashIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Address } from '@/api/addresses/types/Address'
import editIcon from '@/components/icons/edit.png'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface AddressPreviewProps {
  address: Address
  onEdit: () => void
  onRemove?: () => void
}

export const AddressPreview = ({ address, onEdit, onRemove }: AddressPreviewProps) => {
  const { t } = useTranslation()
  return (
    <Card key={address.id} className='border-border-default flex gap-4 border bg-white p-6'>
      <CardContent className='flex p-0'>
        <div className='flex grow flex-col items-start'>
          {address.isDefault && (
            <div className='text-text-secondary bg-button-primary-selected-segment mb-2 rounded-full px-2 py-1 text-xs'>
              {t('profile.defaultAddress')}
            </div>
          )}
          <div className='text-text-secondary text-sm'>
            {address.street}
            {address.apartment && `, ${t('profile.apartment')} ${address.apartment}`}
            <br />
            {address.city}, {address.postalCode}
          </div>
          {address.note && <div className='text-text-secondary text-xs'>{address.note}</div>}
        </div>
        <div className='flex items-center gap-2 self-end'>
          {onRemove && (
            <Button variant='ghost' size='icon' className='!h-6 !w-6' onClick={onRemove}>
              <TrashIcon className='size-4' />
            </Button>
          )}
          <Button variant='secondary' className='px-4' icon={<img src={editIcon} alt='edit' className='size-5' />} onClick={onEdit}>
            {t('profile.editAddress')}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
